module.exports = __webpack_public_path__ + "static/media/defaultAvatar28.67595915.svg";